export function smsReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_SMS":
            return payload;
        
        default:
            return state;
    }
}